var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { FavoriteUserListName, } from '@interfaces/favorite-user.interface';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadActiveAccount } from '@popup/steem/actions/active-account.actions';
import { FavoriteAccountsListComponent } from '@popup/steem/pages/app-container/settings/user-preferences/favorite-accounts/favorite-accounts-list/favorite-accounts-list.component';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const FavoriteAccounts = ({ accounts, activeAccount, localAccounts, loadActiveAccount, setTitleContainerProperties, }) => {
    const defaultOptions = [];
    const [options, setOptions] = useState(defaultOptions);
    const [selectedLocalAccount, setSelectedLocalAccount] = useState(accounts[0].name);
    const [favoriteAccountsList, setFavoriteAccountsList] = useState([{ name: FavoriteUserListName.USERS, list: [] }]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_favorite_accounts',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        init();
        setOptions(accounts.map((account) => {
            return { label: account.name, value: account.name };
        }));
        setSelectedLocalAccount(activeAccount.name);
    }, [accounts, activeAccount]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        const favoriteUsers = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS);
        yield FavoriteUserUtils.fixFavoriteList(favoriteUsers);
        setFavoriteAccountsList([
            {
                name: FavoriteUserListName.USERS,
                list: favoriteUsers[activeAccount.name],
            },
        ]);
    });
    // const handleItemClicked = (accountName: string) => {
    //   const itemClicked = accounts.find(
    //     (account: LocalAccount) => account.name === accountName,
    //   );
    //   loadActiveAccount(itemClicked!);
    // };
    // const customLabelRender = (
    //   selectProps: SelectRenderer<LocalAccountListItem>,
    // ) => {
    //   return (
    //     <div
    //       className="selected-account-panel"
    //       onClick={() => {
    //         selectProps.methods.dropDown('close');
    //       }}>
    //       <img
    //         src={`https://steemitimages.com/u/${selectedLocalAccount}/avatar`}
    //         onError={(e: any) => {
    //           e.target.onError = null;
    //           e.target.src = '/assets/images/accounts.png';
    //         }}
    //       />
    //       <div className="selected-account-name">{selectedLocalAccount}</div>
    //     </div>
    //   );
    // };
    // const customItemRender = (
    //   selectProps: SelectItemRenderer<LocalAccountListItem>,
    // ) => {
    //   return (
    //     <div
    //       data-testid={`select-account-item-${selectProps.item.label}`}
    //       className={`select-account-item ${
    //         selectedLocalAccount === selectProps.item.value ? 'selected' : ''
    //       }`}
    //       onClick={() => {
    //         handleItemClicked(selectProps.item.value);
    //         selectProps.methods.dropDown('close');
    //       }}>
    //       <img
    //         src={`https://steemitimages.com/u/${selectProps.item.label}/avatar`}
    //         onError={(e: any) => {
    //           e.target.onError = null;
    //           e.target.src = '/assets/images/accounts.png';
    //         }}
    //       />
    //       <div className="account-name">{selectProps.item.label}</div>
    //     </div>
    //   );
    // };
    const handleDeleteFavorite = (listName, favoriteItem) => {
        const favoriteAccountsListCopy = [...favoriteAccountsList];
        const selectedList = favoriteAccountsListCopy.filter((favoriteList) => favoriteList.name === listName)[0];
        const filteredSelectedList = selectedList.list.filter((favorite) => favorite !== favoriteItem);
        selectedList.list = filteredSelectedList;
        setFavoriteAccountsList([...favoriteAccountsListCopy]);
        saveFavoriteList(selectedList);
    };
    const saveFavoriteList = (list) => __awaiter(void 0, void 0, void 0, function* () {
        const actualFavoriteUsersLists = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS);
        const updatedFavoriteUserLists = Object.assign(Object.assign({}, actualFavoriteUsersLists), { [activeAccount.name]: list.list });
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS, updatedFavoriteUserLists);
    });
    const handleEditFavoriteLabel = (listName, favoriteItem, newLabel) => {
        const favoriteAccountsListCopy = [...favoriteAccountsList];
        const selectedList = favoriteAccountsListCopy.filter((favoriteList) => favoriteList.name === listName)[0];
        const favoriteItemIndexToEdit = selectedList.list.findIndex((favorite) => favorite === favoriteItem);
        selectedList.list[favoriteItemIndexToEdit] = Object.assign(Object.assign({}, selectedList.list[favoriteItemIndexToEdit]), { subLabel: newLabel });
        setFavoriteAccountsList([...favoriteAccountsListCopy]);
        saveFavoriteList(selectedList);
    };
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_FAVORITE_ACCOUNTS}-page`, className: "favorite-accounts-page" },
        React.createElement("div", { className: "intro" }, getMessage('popup_html_favorite_accounts_intro')),
        React.createElement(SelectAccountSectionComponent, { background: "white", fullSize: true }),
        React.createElement(FavoriteAccountsListComponent, { key: `${Math.random().toFixed(6).toString()}-${FavoriteUserListName.USERS}`, favoriteList: favoriteAccountsList.filter((favoriteList) => favoriteList.name === FavoriteUserListName.USERS)[0], handleDeleteFavorite: handleDeleteFavorite, handleEditFavoriteLabel: handleEditFavoriteLabel })));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
        activeAccount: state.steem.activeAccount,
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    loadActiveAccount,
    setTitleContainerProperties,
});
export const FavoriteAccountsComponent = connector(FavoriteAccounts);
